import { CreditCardFormValues } from '@ott/credit-card';

export type RefillFormType = CreditCardFormValues & {
  id?: string;
  selectedId: string;
  amount: string;
};

export type RefillCard = {
  cardHolder: string;
  cardId: string;
  cardMask: string;
  cardNumber?: string;
  cardName: string;
  status: string;
  isOTTCard: boolean;
  issuingNetwork: string;
};

export const enum CardStatuses {
  /** дебетовая карта */
  DebtCard = 'debtCard',
  /** виртуальная карта (не пройден УПРИД) */
  Anonymous = 'anonymous',
  /** виртуальная карта (пройден УПРИД) */
  SimplyIdentified = 'simplyIdentified',
}
